import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";

const theme = createTheme({
	palette: {
		mode: "dark",
		primary: {
			main: "#F97316", // Google Meet active blue
			contrastText: "#121212",
		},
		secondary: {
			main: "#e8eaed", // High contrast white/gray
			contrastText: "#121212",
		},
		error: {
			main: "#ea4335", // Google Meet red
		},
		background: {
			default: "#0a0a0a", // Ultra-dark background
			paper: "#1e1e1e", // Charcoal surface for cards
		},
		text: {
			primary: "#ffffff",
			secondary: "#9e9e9e", // Clean cool gray
		},
	},
	shape: {
		borderRadius: 12, // Subtle rounded corners
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 8, // Clean Google-style rounded button
					textTransform: "none",
					fontWeight: 500,
					padding: "8px 20px",
				},
			},
		},
		MuiTextField: {
			defaultProps: {
				variant: "outlined",
				size: "medium",
			},
			styleOverrides: {
				root: {
					"& .MuiOutlinedInput-root": {
						borderRadius: 8,
					},
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					borderRadius: 16,
					backgroundColor: "#1e1e1e",
					backgroundImage: "none", // Remove default MUI dark elevation overlay gradient
					border: "1px solid rgba(255, 255, 255, 0.08)",
				},
			},
		},
	},
	typography: {
		fontFamily: '"Google Sans", "Product Sans", Inter, Roboto, sans-serif',
	},
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<App />
		</ThemeProvider>
	</React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
